import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { IMPERSONATE } from '@/graphql/mutations';
import useSetAuthTokenAndUser from 'data-hooks/useUserData/useSetAuthTokenAndUser';
const Impersonate = t0 => {
  const $ = _c(9);
  const {
    hash
  } = t0;
  const history = useHistory();
  const [error, setError] = useState(null);
  const setAuthTokenAndUser = useSetAuthTokenAndUser();
  let t1;
  if ($[0] !== history || $[1] !== setAuthTokenAndUser) {
    t1 = {
      onCompleted: async data => {
        const {
          user,
          errors
        } = data.impersonate;
        if (!user) {
          const message = get(errors, "0.message", null);
          setError(message || "Login failed. Please try again");
        } else {
          const {
            access_token,
            email,
            first_name,
            group_id,
            id,
            is_designer,
            is_impersonate,
            last_name,
            user_discount
          } = user;
          await setAuthTokenAndUser({
            access_token,
            email,
            first_name,
            group_id,
            id,
            is_designer,
            is_impersonate,
            last_name,
            refresh_token: "",
            user_discount
          });
          history.push("/customer/dashboard");
        }
      }
    };
    $[0] = history;
    $[1] = setAuthTokenAndUser;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [impersonate] = useMutation(IMPERSONATE, t1);
  let t2;
  let t3;
  if ($[3] !== hash || $[4] !== impersonate) {
    t2 = () => {
      impersonate({
        variables: {
          hash
        }
      });
    };
    t3 = [hash, impersonate];
    $[3] = hash;
    $[4] = impersonate;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== error) {
    t4 = <div className="Impersonate">{error ? <div className="text-lg font-bold min-h-[80vh] pt-48 text-red text-center">{error}</div> : <div className="flex items-center justify-center text-lg font-bold min-h-[80vh]">loading...</div>}</div>;
    $[7] = error;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
Impersonate.propTypes = {
  hash: PropTypes.string.isRequired
};
export default Impersonate;